.select {
  .label {
    display: block;
    color: var(--bc-color-text-secondary);
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 12px;
    margin-bottom: 9px;
  }

  .tag {
    width: 100%;
  }

  .hideTag {
    display: none;
  }

  :global {
    .ant-select {
      width: 100%;
    }
  }

  &.error {
    :global {
      .ant-select {
        border: 1px solid var(--bc-color-error);
        &:hover, &:active, &:focus {
          border: 1px solid var(--bc-color-error);
        };
      }
    }
  }
}

.sizeFix {
  height: var(--bc-control-height);
}

.sizeFixLG {
  height: var(--bc-control-height-lg);
}

.selectAll {
  display: flex;
  align-items: center;
  margin-bottom: calc(var(--bc-padding-xs) / 2);
  cursor: pointer;
  user-select: none;

  &.selectAllDisabled {
    cursor: not-allowed;
  }

  .selectAllBody {
    display: flex;
    align-items: center;
    flex: 1;
    padding: 8px 0;
    margin-left: 8px;
    border-radius: var(--bc-border-radius);
  }

  &:not(.selectAllDisabled) .selectAllBody:hover {
    background-color: var(--bc-tree-select-node-hover-bg);
  }

  .selectAllBox {
    --size: 16px;
    position: relative;
    display: inline-block;
    flex: none;
    box-sizing: border-box;
    width: var(--size);
    height: var(--size);
    background-color: var(--bc-color-bg-container);
    border: var(--bc-line-width) solid var(--bc-color-border);
    border-radius: var(--bc-border-radius-sm);
    transition: all var(--bc-motion-duration-slow);

    &:after {
      box-sizing: border-box;
      position: absolute;
      top: calc(var(--size) / 2 - var(--bc-line-width));
      left: calc(var(--size) / 4 - var(--bc-line-width));
      display: table;
      width: calc(var(--size) / 14 * 5);
      height: calc(var(--size) / 14 * 8);
      border: var(--bc-line-width-bold) solid var(--bc-color-white);
      border-top: 0;
      border-left: 0;
      transform: rotate(45deg) scale(0) translate(-50%, -50%);
      opacity: 0;
      content: "";
      transition: all var(--bc-motion-duration-fast) var(--bc-motion-ease-in-back);
    }
  }

  .selectAllBoxChecked {
    background-color: var(--bc-color-primary);
    border-color: var(--bc-color-primary);

    &:after {
      opacity: 1;
      transform: rotate(45deg) scale(1) translate(-50%, -50%);
      transition: all var(--bc-motion-duration-mid) var(--bc-motion-ease-out-back) var(--bc-motion-duration-fast);
    }
  }

  .selectAllBoxIndeterminate {
    background-color: var(--bc-color-bg-container);
    border-color: var(--bc-color-border);

    &:after {
      top: 50%;
      left: 50%;
      width: calc(var(--bc-font-size-lg) / 2);
      height: calc(var(--bc-font-size-lg) / 2);
      background-color: var(--bc-color-primary);
      border: 0;
      transform: translate(-50%, -50%) scale(1);
      opacity: 1;
    }
  }

  .selectAllBoxDisabled {
    background-color: var(--bc-color-bg-container-disabled);
    border-color: var(--bc-color-border);

    &:after {
      border-color: var(--bc-color-text-disabled);
    }

    &.selectAllBoxIndeterminate:after {
      background-color: var(--bc-color-text-disabled);
    }
  }

  &:not(.selectAllDisabled):hover .selectAllBox:not(.selectAllBoxChecked) {
    border-color: var(--bc-color-primary);
  }

  &:not(.selectAllDisabled):hover .selectAllBoxChecked {
    background-color: var(--bc-color-primary-hover);
    border-color: transparent;
  }

  .selectAllLabel {
    margin-left: var(--bc-padding-xs);
    color: inherit;
    line-height: 1;
  }

  &.selectAllDisabled .selectAllLabel {
    color: var(--bc-color-text-disabled);
  }
}

.suffix {
  display: flex;
}

.treeDropdown {
  border-radius: 8px;

  :global {
    .ant-select-tree-checkbox {
      margin-left: 8px;
    }

    .ant-select-tree-switcher {
      order: 1;
    }
  }
}

.treeItem {
  font-size: var(--bc-select-option-font-size);
}

.errorContainer {
  margin-top: 6px;
  font-size: 12px;
  line-height: 12px;
  color: var(--bc-color-error);

  .icon {
    font-size: 13px;
    color: var(--bc-color-error);
    margin-right: 5px;
  }
}
